import { Auth } from 'aws-amplify';

const forgotPassword = email => {
  if (!email) throw new Error('Email is empty');
  return Auth.forgotPassword(email.trim());
};

export default forgotPassword;
